import { useTrivia } from '../../../../hooks';
import { ResultOptionTrivia, TriviaReport } from './';

export const ResultTrivia = () => {
  const { result } = useTrivia();
  return (
    <>
        <li className="splide__slide" style={{ height: '100%'}} id='result-trivia-report'>
            <div className="trivia" style={{ overflowY: 'auto'}}>
                <div className="trivia__score">
                    <h2 className="trivia__score-title">Resultados</h2>
                    <div className="trivia__score-board">
                        {
                            result?.map( question => (
                                <ResultOptionTrivia key={question.question?.id} question={question}/>
                            ))
                        }
                    </div>
                </div>
            </div>
        </li>
        <div id='table-report-trivia' style={{ display: 'none'}}>
            <TriviaReport/>
        </div>
    </>
  )
}